import axios from "axios";
import Config from "@/config/config";
import Path from "@/lib/common/path";
import Auth from "@/lib/common/auth";

export class ACM {
  static loadConfigFile(configName: string): any {
    const storageKey = "ConfigCache_" + configName;
    return localStorage.getItem(storageKey);
  }

  static updateConfigFile(configName: string): any {
    return new Promise(function(resolve, reject) {
      const storageKey = "ConfigCache_" + configName;
      axios
        .create()
        .post(Path.join(Config.apiUrl, "aiExam/common/getAcmConfig"), {
          dataId: configName
        })
        .then((resp: { data: any }) => {
          if (resp.data.code === 0) {
            resolve(resp.data.data.acmConfigValue);
            localStorage.setItem(storageKey, resp.data.data.acmConfigValue);
          } else {
            reject();
          }
        })
        .catch(() => {
          reject();
        });
    });
  }
}

export class CompanyConfig {
  private static instance: CompanyConfig;

  companyId = 0;
  // 考试面包屑是否显示备注
  breadCrumbShowRemark = 0;
  // 报告页的通过Logo类型
  resultLogoType = 0;
  // 导出候选人格式
  exportCandidateType = 0;
  // 显示导出全部按钮
  showExportAllButton = 0;
  // 侧边栏是否显示虚拟主播入口
  showVirtualAvatarMenu = 0;
  // 展示中位数数据
  showMiddleScore = 0;
  // 视频题 是否可设置 准备时间 和 回答时长
  preparationTime = 0;
  // 是否隐藏手机号
  isHidePhone = 0;
  //阅卷评语是否必填
  isMustResultText = 0;
  //评语最低字数
  resultTextMinNumber = 0;
  //是否展示简历链接
  isShowAttachment = 0;
  //是否开启视频题各个小维度打分
  isMarkDimensionScore = 0;
  //报告页 是否隐藏AI推荐
  isHideResultAiStar = 0;
  //是否需要加密报告页链接
  encodeCandidateDataInReportPage = 0;
  //是否有 ATS系统 （牛人星球）
  openAtsSystem = 0;
  //是否富士康类型公司
  isTestExamCompany = 0;
  // 是否得物公司(公开二维码白名单验证)
  usePublicCodeWhiteList = 0;
  //小程序二维码cover图片url   为空则不用cover
  mpLogo = "";
  // 首页隐藏职位组入口
  closeJobList = 0;
  // 首页隐藏AI面试官入口
  closeAiGroup = 0;
  // 是否可以增加额外的面试须知语
  canEditExamVideoList = 0;
  // 立讯背调定制特判规则，金融中风险、未查询、身份信息异常等情况视为通过
  backgroundCheckJudgment = 0;
  // 是否采用多标签
  useMultiTag = 0;
  // 候选人列表和消息通知列表是否模糊搜索
  fuzzySearch = 0;
  // 是否展示意向城市筛选框
  showCitySelect = 0;
  //公司是否可以配置报告页提取码
  enableReportCertiCode = 0;

  private constructor(companyId: number) {
    this.companyId = companyId;
  }

  static getInstance(companyId = 0) {
    if (companyId == 0) companyId = parseInt(Auth.companyId);
    if (!this.instance || this.instance.companyId != companyId) {
      this.instance = new CompanyConfig(companyId);
      this.instance.loadConfig();
    }
    return this.instance;
  }

  async loadConfig() {
    try {
      const companyConfig = JSON.parse(ACM.loadConfigFile("company_config"));
      //约定：以公司id0的配置为默认值
      Object.assign(this, companyConfig[0]);
      if (this.companyId.toString() in companyConfig) {
        Object.assign(this, companyConfig[this.companyId.toString()]);
      }
    } catch (e) {
      console.log(e);
    }
    return this;
  }
}
